import axios, { baseRequestConfig } from './base';


export function getOrganizerTasks(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_organizer_mytasks',
        values,
      },
    },
  });
}

export function getOrganizerProjects(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_organizer_myprojects',
        values,
      },
    },
  });
}

export function getOrganizerProjectsBasicDetails(userToken) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_organizer_myprojects',
        values: {
          detail: 'NONE',
        },
      },
    },
  });
}

export function searchOrganizerTasks(userToken, taskSearchValue) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_organizer_mytasks',
        values: {
          task_name_search: taskSearchValue,
        },
      },
    },
  });
}

export function searchOrganizerProjects(userToken, projectNameSearch) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'user_organizer_myprojects',
        values: {
          project_name_search: projectNameSearch,
        },
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/organizer.js